<script lang="ts">
	import * as m from '$lib/paraglide/messages';
	import { localizeHref } from '$lib/paraglide/runtime';
	import brandMarkDarkBackground from '$lib/assets/samlla-znak-kolor-ciemne-tlo.svg';
	import brandMarkLightBackground from '$lib/assets/samlla-znak-kolor-jasne-tlo.svg';

	let { isAuthenticated = false }: { isAuthenticated?: boolean } = $props();
</script>

<footer class="site-foot">
	<div class="foot-inner">
		<div class="foot-lead">
			<a href={localizeHref('/')} class="foot-brand">
				<span class="brand-mark" aria-hidden="true">
					<img
						class="foot-logo brand-mark-light"
						src={brandMarkLightBackground}
						alt=""
						width="22"
						height="22"
					/>
					<img
						class="foot-logo brand-mark-dark"
						src={brandMarkDarkBackground}
						alt=""
						width="22"
						height="22"
					/>
				</span>
				<span>Samlla</span>
			</a>
			<p class="foot-tag">{m.landing_foot_tag()}</p>
			<div class="foot-early"><span class="pulse-dot"></span>{m.landing_foot_early()}</div>
		</div>
		<div class="foot-cols">
			<div class="foot-col">
				<div class="foot-col-h">{m.landing_foot_col_product()}</div>
				<a href={localizeHref('/features')}>{m.landing_nav_features()}</a>
				<a href={localizeHref('/pricing')}>{m.landing_nav_pricing()}</a>
			</div>
			<div class="foot-col">
				<div class="foot-col-h">{m.landing_foot_col_legal()}</div>
				<a href={localizeHref('/privacy')}>{m.landing_privacy()}</a>
				<a href={localizeHref('/terms')}>{m.landing_terms()}</a>
				<a href="mailto:support@samlla.app">{m.landing_footer_contact()}</a>
			</div>
			<div class="foot-col">
				<div class="foot-col-h">{m.landing_foot_col_account()}</div>
				{#if isAuthenticated}
					<a href={localizeHref('/app/journal')}>{m.landing_go_to_app()}</a>
				{:else}
					<a href={localizeHref('/auth/login')}>{m.landing_account_login()}</a>
				{/if}
			</div>
		</div>
	</div>
	<div class="foot-meta">
		<div class="foot-meta-inner">
			<span>{m.landing_footer_copyright()}</span>
			<span>EN · PL</span>
		</div>
	</div>
</footer>
